import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import type { PostUserLoginRequestBody } from '@brilltek42/template-types'
import { message } from 'antd'

import { Link } from '@/components/atoms'
import { UserLoginForm } from '@/components/organisms'

import { useAuth, useNavigation } from '@/hooks'
import { handleError } from '@/utils/Error'

export const LoginPage = () => {
  const navigation = useNavigation()
  const location = useLocation()
  const { t } = useTranslation()
  const { login, isAuthenticated } = useAuth()

  const handleAuthentication = async (formData: PostUserLoginRequestBody) => {
    try {
      await login(formData)
      message.success({ content: t('Success', { action: t('Login') }) })
      navigation.goTo(location.state?.prevPage ?? 'overview', { replace: true })
    } catch (e) {
      handleError(e)
    }
  }

  useEffect(() => {
    if (isAuthenticated) {
      navigation.goTo('overview')
    }
  }, [isAuthenticated])

  return (
    <div className="flex h-full flex-col items-center justify-center p-2">
      <div className="flex flex-col">
        <div className="mb-10 border-b-2  border-slate-600 text-4xl text-slate-800">
          Brilltek template
        </div>
        <UserLoginForm onSubmit={handleAuthentication} />
      </div>

      <div className="mt-8 border-t-2 border-slate-800">
        <Link
          className="m-2 rounded-md p-2 text-base hover:text-slate-600"
          onClick={() => {
            message.info({ content: 'coming soooon!' })
          }}
        >
          {t('AskForgetPassword')}
        </Link>
      </div>
    </div>
  )
}
